function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { context, propagation, SpanStatusCode, trace } from '@opentelemetry/api';
var defaultOptions = {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    }
};
/**
 * `Content-Type` header other than 'application/json' disables the automatic `json.stringify()` for the request body
 * `Accept` header other than 'application/json' disables the automatic `res.json()` parsing. `data` returns `undefined`
 */ export function xrequest(url, options) {
    return _xrequest.apply(this, arguments);
}
function _xrequest() {
    _xrequest = _async_to_generator(function(url, options) {
        var finalOptions, _window_DD_LOGS_getInternalContext, _window_DD_LOGS_getInternalContext1, _window_DD_LOGS, _window, _window_FS, _window1, DDSessionId, fullStorySessionId, tracer, urlObject;
        return _ts_generator(this, function(_state) {
            finalOptions = _object_spread_props(_object_spread({}, defaultOptions, options), {
                headers: _object_spread({}, defaultOptions.headers, (options === null || options === void 0 ? void 0 : options.headers) || {})
            });
            if (typeof window !== 'undefined') {
                ;
                // Add pageName header for client-side requests
                finalOptions.headers.pageName = encodeURI(window.document.title);
                // Attach Datadog & FullStory session IDs to each request
                DDSessionId = ((_window = window) === null || _window === void 0 ? void 0 : (_window_DD_LOGS = _window.DD_LOGS) === null || _window_DD_LOGS === void 0 ? void 0 : (_window_DD_LOGS_getInternalContext1 = _window_DD_LOGS.getInternalContext) === null || _window_DD_LOGS_getInternalContext1 === void 0 ? void 0 : (_window_DD_LOGS_getInternalContext = _window_DD_LOGS_getInternalContext1.call(_window_DD_LOGS)) === null || _window_DD_LOGS_getInternalContext === void 0 ? void 0 : _window_DD_LOGS_getInternalContext.session_id) || '';
                fullStorySessionId = ((_window1 = window) === null || _window1 === void 0 ? void 0 : (_window_FS = _window1.FS) === null || _window_FS === void 0 ? void 0 : _window_FS.call(_window1, 'getSession', {
                    format: 'id'
                })) || '';
                finalOptions.headers.dd_session_id = DDSessionId;
                finalOptions.headers.fs_session_id = fullStorySessionId;
            }
            // Automatically stringify body for JSON content
            if ((options === null || options === void 0 ? void 0 : options.body) && finalOptions.headers['Content-Type'].includes('application/json')) {
                finalOptions.body = JSON.stringify(options.body);
            }
            tracer = trace.getTracer(process.env.NEXT_PUBLIC_OTEL_SERVICE_NAME || 'unknown');
            urlObject = generateValidUrl(url);
            return [
                2,
                new Promise(function(resolve, reject) {
                    // Ensure the span is created as a child of the active context
                    tracer.startActiveSpan("fetch ".concat(finalOptions.method, " ").concat(urlObject.pathname), {
                        kind: typeof window === 'undefined' ? 1 : 2,
                        attributes: {
                            'dd.session_id': finalOptions.headers.dd_session_id,
                            'fs.session_id': finalOptions.headers.fs_session_id,
                            'resource.name': "".concat(urlObject.origin).concat(urlObject.pathname),
                            'net.peer.name': urlObject.hostname,
                            'net.peer.port': urlObject.port,
                            'http.url': url,
                            'http.host': urlObject.host,
                            'http.scheme': urlObject.protocol.replace(':', ''),
                            'http.method': finalOptions.method,
                            'http.query': urlObject.search,
                            'http.request.headers': JSON.stringify(finalOptions.headers),
                            'http.request.body': finalOptions.body ? JSON.stringify(finalOptions.body) : ''
                        }
                    }, /*#__PURE__*/ function() {
                        var _ref = _async_to_generator(function(span) {
                            var baggage, _baggage_getEntry, _baggage_getEntry1, _baggage_getEntry2;
                            return _ts_generator(this, function(_state) {
                                try {
                                    // Retrieve user session info from Opentelemetry context if available
                                    // and attach to the current request span
                                    baggage = propagation.getBaggage(context.active());
                                    if (baggage) {
                                        ;
                                        span.setAttributes({
                                            'user.id': (_baggage_getEntry = baggage.getEntry('user.id')) === null || _baggage_getEntry === void 0 ? void 0 : _baggage_getEntry.value,
                                            'user.role': (_baggage_getEntry1 = baggage.getEntry('user.role')) === null || _baggage_getEntry1 === void 0 ? void 0 : _baggage_getEntry1.value,
                                            'user.email': (_baggage_getEntry2 = baggage.getEntry('user.email')) === null || _baggage_getEntry2 === void 0 ? void 0 : _baggage_getEntry2.value
                                        });
                                    }
                                    fetch(url, finalOptions).then(/*#__PURE__*/ function() {
                                        var _ref = _async_to_generator(function(res) {
                                            var _$error, errorText, e, clonedResponse, data, e1, _$error1;
                                            return _ts_generator(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        span.setAttributes({
                                                            'http.status_code': res.status,
                                                            'http.response.headers': JSON.stringify(res.headers)
                                                        });
                                                        if (!!res.ok) return [
                                                            3,
                                                            5
                                                        ];
                                                        _state.label = 1;
                                                    case 1:
                                                        _state.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        return [
                                                            4,
                                                            res.text()
                                                        ];
                                                    case 2:
                                                        errorText = _state.sent();
                                                        _$error = new Error(errorText);
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 3:
                                                        e = _state.sent();
                                                        _$error = new Error('Request failed with the following Error:' + e);
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 4:
                                                        span.setStatus({
                                                            code: SpanStatusCode.ERROR,
                                                            message: _$error.message
                                                        });
                                                        span.setAttribute('http.error', true);
                                                        span.setAttribute('http.error.message', _$error.message);
                                                        reject(_$error);
                                                        return [
                                                            2
                                                        ];
                                                    case 5:
                                                        if (!(res.status !== 204 || // No content status
                                                        finalOptions.headers['Accept'].includes('application/json') // JSON accepted
                                                        )) return [
                                                            3,
                                                            10
                                                        ];
                                                        _state.label = 6;
                                                    case 6:
                                                        _state.trys.push([
                                                            6,
                                                            8,
                                                            ,
                                                            9
                                                        ]);
                                                        clonedResponse = res.clone(); // Clone the response safely
                                                        return [
                                                            4,
                                                            clonedResponse.json()
                                                        ];
                                                    case 7:
                                                        data = _state.sent();
                                                        span.setAttribute('http.response.body', JSON.stringify(data));
                                                        resolve({
                                                            res: res,
                                                            data: data
                                                        }); // Return the original response and parsed data
                                                        return [
                                                            3,
                                                            9
                                                        ];
                                                    case 8:
                                                        e1 = _state.sent();
                                                        _$error1 = new Error('Request failed with the following Error:' + e1);
                                                        span.setStatus({
                                                            code: SpanStatusCode.ERROR,
                                                            message: _$error1.message
                                                        });
                                                        span.setAttributes({
                                                            'http.error': true,
                                                            'http.error.message': _$error1.message
                                                        });
                                                        reject(_$error1);
                                                        return [
                                                            3,
                                                            9
                                                        ];
                                                    case 9:
                                                        return [
                                                            2
                                                        ];
                                                    case 10:
                                                        // Handle no-content status
                                                        resolve({
                                                            res: res,
                                                            data: undefined
                                                        });
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        });
                                        return function(res) {
                                            return _ref.apply(this, arguments);
                                        };
                                    }()).finally(function() {
                                        return span.end();
                                    });
                                } catch (error) {
                                    span.setStatus({
                                        code: SpanStatusCode.ERROR,
                                        message: error.message
                                    });
                                    span.setAttributes({
                                        'http.error': true,
                                        'http.error.message': error.message
                                    });
                                    reject(error);
                                }
                                return [
                                    2
                                ];
                            });
                        });
                        return function(span) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                })
            ];
        });
    });
    return _xrequest.apply(this, arguments);
}
export function generateValidUrl(url) {
    // if is valid url
    if (!url.startsWith('http') && typeof window !== 'undefined') {
        return new URL(url, window.location.origin);
    } else {
        // Include origin to API requests without it. Example:
        // From /api/path to https://domain.com/api/path
        var host = process.env.VERCEL_URL ? "https://".concat(process.env.VERCEL_URL) : 'http://localhost:3000';
        return new URL(url, host);
    }
}
/**
 * Format URL with search parameters
 * @param url - The base URL to format
 * @param searchParams - An object containing the search parameters to add to the URL
 * @returns The formatted URL with the search parameters
 * @example
 * formatURLSearchParams('https://example.com', {foo: 'bar', baz: ['qux', 'quux']})
 * // Returns 'https://example.com?foo=bar&baz[]=qux&baz[]=quux'
 */ export var formatURLSearchParams = function(url, searchParams) {
    var newUrl = generateValidUrl(url);
    Object.entries(searchParams).forEach(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        if (Array.isArray(value)) {
            value.forEach(function(item) {
                newUrl.searchParams.append("".concat(key, "[]"), item);
            });
        } else {
            newUrl.searchParams.set(key, value);
        }
    });
    return newUrl.toString();
};
